import { render, staticRenderFns } from "./ResidentMonitoredHealth.vue?vue&type=template&id=37fbabe0&"
import script from "./ResidentMonitoredHealth.vue?vue&type=script&lang=js&"
export * from "./ResidentMonitoredHealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports